import { h } from "preact";

import style from "./style";

/**
 * A parent component unorderd list for consistantly displpayed lists
 * @param {Boolean} inColumns adds a class to display list in 3 columns
 * @param {Components} children One or more child components
 */
const ResultList = ({ inColumns, children }) => {
  const styles = [style["title-list__list"]];
  if (inColumns) {
    styles.push(style["in-columns"]);
  }
  return <ul class={styles.join(" ")}>{children}</ul>;
};

export default ResultList;
